/* eslint-env es2016, browser */
'use strict';

import './editeur.js';
import './fast.js';
import './forms.js';
import './tabs.js';

document.addEventListener('DOMContentLoaded', () =>
	document.body.classList.add('vp-loaded')
);
